export default {
	links: [
		{
			name: 'За дома',

			dropdownItems: [
				{
					name: 'Срочни',
					href: '/za-doma/',
					external: false
				},
				{
					name: 'Безсрочни',
					href: '/za-doma-bezsrochni/',
					external: false
				}
			]
		},
		{
			name: 'За бизнеса',
			dropdownItems: [
				{
					name: 'Срочни',
					href: '/za-biznesa/',
					external: false
				},
				{
					name: 'Безсрочни',
					href: '/za-biznesa-bezsrochni/',
					external: false
				}
			]
		},
		{
			name: 'Освободи се',
			dropdownItems: [
				{
					name: 'Освободи се',
					href: '/osvobodi-se/',
					external: false
				},
				{
					name: 'Свобода',
					href: '/osvobodi-se/svoboda/',
					external: false
				},
				{
					name: 'Доведи Приятел',
					href: '/osvobodi-se/dovedi-priyatel/',
					external: false
				},
				{
					name: 'Закрилникът',
					href: '/osvobodi-se/internet-zashtita/',
					external: false
				},
				{
					name: 'Netsurf Play',
					href: '/osvobodi-se/netsurf-play/',
					external: false
				},
				{
					name: 'ТипТок',
					href: '/osvobodi-se/tip-tok/',
					external: false
				},
			]
		},
		{
			name: 'Промоции',
			showPromoIcon: true,
			href: '/promocii/',
			external: false
		},


		{
			name: 'Aurora TV',
			href: '/aurora-tv/',
			external: false
		},
		{
			name: 'За Теб',
			dropdownItems: [
				{
					name: 'Какво е GPON',
					href: '/kakvo-e-gpon/',
					external: false
				},
				{
					name: 'Защо NetSurf',
					href: '/zashto-netsurf/',
					external: false
				},
				{
					name: 'Помощ',
					href: '/help-center/',
					external: false
				},
				{
					name: 'Блог',
					href: undefined,
					externalHref: 'https://blog.netsurf.bg/',
					external: true
				}
			]
		}
	]
};

